var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5303 0.469691C17.7545 0.693816 17.8135 1.03464 17.6778 1.32109L10.0989 17.3211C9.96327 17.6074 9.66241 17.7776 9.34717 17.7464C9.03193 17.7152 8.7703 17.4892 8.69346 17.1819L7.11839 10.8816L0.818117 9.30657C0.510795 9.22974 0.284884 8.96811 0.253669 8.65287C0.222454 8.33763 0.392667 8.03678 0.678954 7.90117L16.679 0.322218C16.9654 0.186532 17.3062 0.245567 17.5303 0.469691ZM3.21503 8.35964L7.91876 9.53557C8.18748 9.60275 8.39729 9.81256 8.46447 10.0813L9.6404 14.785L15.4232 2.57681L3.21503 8.35964Z",
    fill: "#BDFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.8b8b7cd8682d41805cd5ca913dd97468.svg";
export { ForwardRef as ReactComponent };